export default __webpack_public_path__ + "static/cover-14-569d04a3f0612bcbf49df227c98031bc.jpg";